import * as Types from '../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type UpdateOfficeOverheadEeCodeMutationVariables = Types.Exact<{
  input: Types.UpdateOfficeOverheadEeCodeCommand;
}>;


export type UpdateOfficeOverheadEeCodeMutation = { __typename?: 'MutationModel', eeCodes: { __typename?: 'EeCodeMutationModel', updateOfficeOverheadEeCode: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const UpdateOfficeOverheadEeCodeDocument = gql`
    mutation UpdateOfficeOverheadEeCode($input: UpdateOfficeOverheadEeCodeCommand!) {
  eeCodes {
    updateOfficeOverheadEeCode(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type UpdateOfficeOverheadEeCodeMutationFn = Apollo.MutationFunction<UpdateOfficeOverheadEeCodeMutation, UpdateOfficeOverheadEeCodeMutationVariables>;

/**
 * __useUpdateOfficeOverheadEeCodeMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeOverheadEeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeOverheadEeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeOverheadEeCodeMutation, { data, loading, error }] = useUpdateOfficeOverheadEeCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfficeOverheadEeCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfficeOverheadEeCodeMutation, UpdateOfficeOverheadEeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfficeOverheadEeCodeMutation, UpdateOfficeOverheadEeCodeMutationVariables>(UpdateOfficeOverheadEeCodeDocument, options);
      }
export type UpdateOfficeOverheadEeCodeMutationHookResult = ReturnType<typeof useUpdateOfficeOverheadEeCodeMutation>;
export type UpdateOfficeOverheadEeCodeMutationResult = Apollo.MutationResult<UpdateOfficeOverheadEeCodeMutation>;
export type UpdateOfficeOverheadEeCodeMutationOptions = Apollo.BaseMutationOptions<UpdateOfficeOverheadEeCodeMutation, UpdateOfficeOverheadEeCodeMutationVariables>;